App.registerBehavior('CookieConsentBanner', function (appSettings) {
  const settings = appSettings['CookieConsentBanner'];
  window.consent = new CookieConsent({
    name: settings.cookie_name || 'cookie_consent',
    onConsent: (consent) => {
      const choices = consent.getChoices();
      consent.saveUserOptions({choices, consented: true});
      // we want to reload the page after consent is given,
      // cause we also handle stuff on the server side
      window.location.reload(false);
    },
    capabilities: resolveCapabilities(settings),
  });

  addAcceptAllClickHandler();
});

function resolveCapabilities(settings) {
  // define default capabilities
  const capabilities = [
    {
      name: 'functional',
      checked: true,
      noOptOut: true,
    }
  ];
  const categories = settings.categories ?? [];
  for (const categoryKey in categories) {
    const category = categories[categoryKey];
    if (category.is_enabled) {
      capabilities.push({
        name: category.name,
        checked: false,
      });
    }
  }
  return capabilities;
}

function addAcceptAllClickHandler() {
  $('[data-cookie-consent="accept-all"]').on('click', function () {
    $('[data-cookie-consent="choices"]').find('input[type="checkbox"]').each(function () {
      $(this).prop("checked", true);
    });
    $('[data-cookie-consent="save-selection"]').trigger('click');
  });
}